const Formatter = (amount, id) => {
    const fomratter = new Intl.NumberFormat("en-US");
    let currencyId = id <= 1 ? " د.ع " : id === 2 ? " $ " : "";
    const formated = fomratter.format(amount);
    return formated + currencyId;
};
export default Formatter;
